import '../assets/css/bookmarks.css'
import '../assets/css/listinvoices.css'
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom"; // pour permettre d'ajouter un param dans l'url
import Logo from '../assets/img/logo-pinkW.svg';
import Loader from '../assets/img/loader.svg';
export function ModifyFacture(props) {
    const numberInvoice = useParams().id
    const cutNumberId = numberInvoice.slice(5)
    const cutNumberCodeId = numberInvoice.slice(0, 5)
    const googleSpreadClient = 'https://spreadsheets.google.com/feeds/list/1QreeDxWPsP9s2FzzvygdpYDFRKaPGPFojNfy_RPR4MI/1/public/values?alt=json' // Si les champs sont ok
    const [dataClient, setSetDataClient] = useState([])
    const [refresh, setRefresh] = useState(0)
    const [load, setLoad] = useState(false)

  
    useEffect(() => {
        
        fetch(googleSpreadClient)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.feed.entry) {
                        setSetDataClient(result.feed.entry)
                        
                    } else {
                        setSetDataClient('empty')
                    }
                    return
                },
                (error) => {
                    setSetDataClient('error')
                }
            )
        return () => setSetDataClient([])
    }, [])
    let dataTachesByDefault = ""


    function splitElement(element){
        const reg1 = /;/gm
        const reg2 = ";\n"
    let arrayTransform = element.replace(reg1,reg2)
    return arrayTransform
    }



    

    return (
        <>
            {props.modalModify == true ?
                props.dataDevisFactures
                    .filter(filtre => filtre.gsx$iddocument.$t.includes(cutNumberId) && filtre.gsx$codeid.$t.includes(cutNumberCodeId))
                    .map((item) => {
                        return (
                        <main className="modalView newFacture modifyFacture">
                            <div className="modal-wrap">
                                <div className="modal-content">
                                    <div className="close-btn" onClick={(e) => {
                                        props.setModalModify(false);
                                    }}>×</div>
                                    <article>
                                    {load === true ? <div className="loader"><img src={Loader} alt="loader" /></div> : null}
                                    <h1 className="titleModal">Modifier {item.gsx$type.$t === "1 Devis" ? "ce devis" :
                                item.gsx$type.$t === "2 Facture d'acompte" ? "cette facture d'acompte" :
                                item.gsx$type.$t === "3 Facture" ? "cette facture" : "ce document"}</h1>
                                
                            <form name="submit-to-google-sheet" onSubmit={(event) => {
                                event.preventDefault()
                                const form = document.forms['submit-to-google-sheet']
                                setLoad(true)
                                fetch(props.scriptURL, { method: 'POST', body: new FormData(form) })
                                    .then(response => {
                                        
                                        props.setRefresh(refresh + 1)
                                        props.setModalModify(false)
                                       setLoad(false)
                                    })
                                    .catch(error => {
                                         console.log("nok")
                                    })
                            }
                            }
                            >
                                <div className="hidden">
                                <input type="text" name="modifyall" readOnly value={item.gsx$id.$t} />
                                    <input type="text" name="type" id="type" required="" readonly="" value={item.gsx$type.$t}/>
                                </div>
                                    <div>
                                        <div>
                                            <label for="codeid">Numéro</label>
                                            <div>
                                                <input type="text" name="codeid" id="codeid" required="" readonly="" value={item.gsx$codeid.$t}/>
                                                <div>-</div>
                                                <input type="number" name="iddocument" id="iddocument" required="" readonly="" value={item.gsx$iddocument.$t}/>
                                            </div>
                                        </div>
                                        <div>
                                             <label for="dateToday">Date</label>
                                             <input type="text" name="date" id="dateToday" required="" defaultValue={item.gsx$date.$t}/>
                                        </div>
                                        <div>
                                                <label for="client">Client</label>
                                                <select name="client" id="client" required>
                                                    <option defaultValue={item.gsx$client.$t} selected>{item.gsx$client.$t}</option>
                                                    {dataClient.map((item) => {
                                                        return (
                                                            <option value={item.gsx$raisonsociales.$t}>{item.gsx$raisonsociales.$t}</option>
                                                        )
                                                    })}
                                                </select>
                                        </div>


                                    </div>
                                    <table>
                                            <thead>
                                                {item.gsx$type.$t==="1 Devis"?
                                                
                                                <tr>
                                                    <th></th>
                                                    <th>
                                                        <span>TVA</span>
                                                        <input type="number" name="tauxtva" id="tauxtva" required min="0" max="100" defaultValue={item.gsx$tauxtva.$t}/>
                                                    </th>
                                                    <th>
                                                        <span>Remise</span>
                                                        <input type="number" name="tauxremise" required min="0" max="100" defaultValue={item.gsx$tauxremise.$t}/>
                                                    </th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                               
                                                : 
                                                <tr>
                                                <th></th>
                                                <th>
                                                    <span className="hidden">TVA</span>
                                                    <input  className="hidden" type="number" name="tauxtva" id="tauxtva" required min="0" max="100" defaultValue={item.gsx$tauxtva.$t}/>
                                                </th>
                                                <th>
                                                    <span className="hidden">Remise</span>
                                                    <input className="hidden" type="number" name="tauxremise" required min="0" max="100" defaultValue={item.gsx$tauxremise.$t}/>
                                                </th>
                                                <th></th>
                                                <th></th>
                                            </tr>}
                                                <tr>
                                                    <th>Tâches</th>
                                                    <th>nb Jours</th>
                                                    <th>TJM</th>
                                                    <th>Total</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                    <td>
                                                        <div>
                                                        <label id="taches">Tâches</label>
                                                        <textarea name="taches">{splitElement(item.gsx$taches.$t)}</textarea>
                                                     
                                                        </div>
                                                        <div>
                                                        <label id="comentairesbytasks">Commentaires</label>
                                                        <textarea name="comentairesbytasks">{splitElement(item.gsx$comentairesbytasks.$t)}</textarea>
                                                        </div>
                                                        
                                                    </td>
                                                    <td>
                                                        <textarea name="jours">{splitElement(item.gsx$jours.$t)}</textarea>
                                                    </td>
                                                    <td><textarea name="tjm">{splitElement(item.gsx$tjm.$t)}</textarea></td>
                                                    <td>total</td>
                                                    <td></td>
                                            
                                            </tr>

                                            {item.gsx$type.$t === "3 Facture"?
                                            <>
                                            <tr className="secondPart">
                                                    <td>Interventions supplémentaires</td>
                                                    <td>nb Jours</td>
                                                    <td>TJM</td>
                                                    <td>Total</td>
                                                    <td></td>
                                            </tr>
                                            <tr>

                                            <td>
                                                        <div>
                                                        <textarea name="tachescomplementaires">{splitElement(item.gsx$tachescomplementaires.$t)}</textarea>
                                                        </div>
                                                        
                                                    </td>
                                                    <td>
                                                        <textarea name="jourscomplementaires">{splitElement(item.gsx$jourscomplementaires.$t)}</textarea>
                                                    </td>
                                                    <td><textarea name="tjmcomplementaires">{splitElement(item.gsx$tjmcomplementaires.$t)}</textarea></td>
                                                    <td>total</td>
                                                    <td>total</td>
                                            </tr>
                                            </>
                                            :null}

                                          
                                            </tbody>

                                        </table>
                                        <div><button action="" method="" type="submit">Modifier {item.gsx$type.$t === "1 Devis" ? "ce devis" :
                                    item.gsx$type.$t === "2 Facture d'acompte" ? "cette facture d'acompte" :
                                    item.gsx$type.$t === "3 Facture" ? "cette facture" : "ce document"}</button></div>
                                </form>














                                    </article>
                                </div>
                                <div class="bg-overlay" onClick={(e) => {
                                    props.setModalModify(false);
                                }}></div>
                            </div>
                        </main>)
                    })
                : null}
        </>
    )
}